import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative flex min-h-screen flex-col bg-black pt-28 pb-16 text-white lg:pt-64 lg:pb-0" }
const _hoisted_2 = { class: "container left-0 right-0 bottom-0 mt-28 w-full lg:mt-12 lg:pb-28" }
const _hoisted_3 = { class: "flex w-full flex-col justify-end space-y-8 lg:ml-auto lg:w-1/2 lg:flex-row lg:space-y-0 lg:space-x-16" }
const _hoisted_4 = {
  key: 0,
  class: "invisible"
}
const _hoisted_5 = { class: "container lg:grid lg:grid-cols-12 lg:gap-x-8" }
const _hoisted_6 = { class: "mb-8 py-12 lg:col-span-6 lg:col-start-4" }
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-box" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "form-placeholder !top-4 text-gray-400" }
const _hoisted_15 = {
  for: "name",
  class: "form-box transition-all duration-1000"
}
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "form-placeholder text-gray-400" }
const _hoisted_18 = { class: "ml-auto flex flex-col" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "container py-4 text-right" }
const _hoisted_21 = { class: "group relative grid gap-y-2.5 lg:cursor-none lg:grid-cols-6 lg:gap-x-1.5 lg:gap-y-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "relative z-10" }
const _hoisted_24 = {
  key: 0,
  class: "hidden items-center justify-between lg:flex"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mx-4 h-px flex-1 bg-current" }, null, -1)
const _hoisted_26 = { class: "relative z-10" }
const _hoisted_27 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_28 = { class: "relative z-10" }
const _hoisted_29 = {
  key: 0,
  class: "mb-2 mt-8 flex flex-wrap items-start gap-2"
}
const _hoisted_30 = { class: "px-4 py-2" }
const _hoisted_31 = { class: "absolute left-0 top-0 h-full w-full overflow-hidden" }
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "container-screen-r container-wide-l pl-container-wide pr-container-screen relative -mx-8 h-full overflow-y-auto overflow-x-hidden bg-white px-4 py-6 lg:overflow-hidden lg:py-20" }
const _hoisted_35 = { class: "absolute top-0 left-0 h-0 w-full pt-1/1 lg:hidden" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "relative z-10 grid pt-1/1 lg:h-full lg:grid-cols-2 lg:gap-x-32 lg:pt-0" }
const _hoisted_39 = { class: "row-start-1 mt-12 lg:col-start-1 lg:mt-24" }
const _hoisted_40 = { class: "absolute -translate-y-full pb-4 lg:relative lg:transform-none lg:pb-0" }
const _hoisted_41 = { class: "hidden lg:inline" }
const _hoisted_42 = { class: "ml-1 hidden lg:inline" }
const _hoisted_43 = { class: "row-start-2 lg:col-start-1 lg:mb-4 lg:mt-20 lg:overflow-y-auto" }
const _hoisted_44 = { class: "prose prose-list prose-ordered-list prose-list-headline-top prose-ul:border-gray-400/30 prose-li:border-gray-400/30" }
const _hoisted_45 = { class: "uppercase text-black" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "my-5 h-0.5 w-10 bg-gray-500" }, null, -1)
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["href", "target"]
const _hoisted_49 = { class: "container-screen-r row-start-4 pt-6 lg:row-span-2 lg:row-start-1 lg:pt-0" }
const _hoisted_50 = {
  key: 0,
  class: "absolute bottom-0 left-0 w-full lg:bottom-8"
}
const _hoisted_51 = { class: "pr-container-screen" }
const _hoisted_52 = { class: "relative h-0.5 w-full bg-gray-400/20" }
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 1,
  class: "absolute left-0 top-0 flex h-full w-full flex-col justify-center bg-black lg:max-h-[60vh]"
}
const _hoisted_55 = { class: "relative h-0 pt-16/9" }
const _hoisted_56 = ["src", "type"]
const _hoisted_57 = {
  key: 2,
  class: "absolute left-0 top-0 flex h-full w-full flex-col justify-center bg-black lg:max-h-[60vh]"
}
const _hoisted_58 = { class: "video relative h-0 pt-16/9" }
const _hoisted_59 = ["src"]
const _hoisted_60 = {
  key: 0,
  class: "row-start-3 mt-16 flex flex-wrap items-start lg:-ml-2 lg:mt-auto"
}
const _hoisted_61 = { class: "px-4 py-2" }

import {
    inject,
    nextTick,
    onBeforeUnmount,
    onMounted,
    provide,
    ref,
    useSlots,
    watch,
    computed
} from 'vue';
import type { Ref } from 'vue';
import { FAQ_REST_ENDPOINT } from '@/bizerba';
import { Faq, FaqResult } from '@/types';
import OverviewFilter from '@/components/overview/OverviewFilter.vue';
import { addToState, filterItems, getMimeType, removeFromState, shuffleArray } from '@/utils';
import BizDropdown from '@/components/base/BizDropdown.vue';
import BizIcon from '@/components/base/BizIcon.vue';
import LoadingSpinner from '@/components/base/LoadingSpinner.vue';
import BizSlider from '@/components/BizSlider.vue';
import BizSlide from '@/components/BizSlide.vue';
import events from '@/events';


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqOverview',
  props: {
    uuid: null,
    questionerLabel: null,
    asksLabel: null,
    backLabel: null,
    shareLabel: null,
    answersLabel: null,
    questionFromLabel: null,
    formPlaceholderLabel: null,
    submitFaqLabel: null,
    questionFieldLabel: null,
    nameFieldLabel: null,
    moreInfoLabel: null,
    mixLabel: null,
    captchaSiteKey: null
  },
  setup(__props: any) {

const props = __props as {
    uuid: string;
    questionerLabel: string;
    asksLabel: string;
    backLabel: string;
    shareLabel: string;
    answersLabel: string;
    questionFromLabel: string;
    formPlaceholderLabel: string;
    submitFaqLabel: string;
    questionFieldLabel: string;
    nameFieldLabel: string;
    moreInfoLabel: string;
    mixLabel: string;
    captchaSiteKey: string;
}

const punycode = require('punycode/');
const contextPath = inject('contextPath');
const siteName = inject('siteName');
const lang = inject('lang');

const currentFaq: Ref<Faq | null> = ref(null);
const faqs: Ref<Faq[]> = ref([]);
const el = ref<HTMLElement | null>(null);
const dropdowns = ref<InstanceType<typeof BizDropdown>[] | null>(null);
const filtersReady = ref(false);
const result: Ref<FaqResult> = ref(null);
const slots = useSlots();
const selectedCategories: string[] = [];
const filters = ref<InstanceType<typeof OverviewFilter>[]>([]);
const x = ref(250);
const y = ref(250);
const mixing = ref(false);
const showSlider = ref(false);
const loading = ref(false);
const submitFaqOpen = ref(false);
const submitFaqLoading = ref(false);
const faqSubmitSuccess = ref(false);
const faqSubmitted = ref(false);
const video = ref(null);
const youtube = ref(null);
const pageUrl = computed(() => location.pathname);
const captchaSolved = ref(false);
// variable used to hide cursor when hover categories
const showCustomCursor = ref(false);
let controller = new AbortController();
let loadFaqSlug = '';

onMounted(async () => {
    window.addEventListener('mousemove', onMouseMove);
    await nextTick();
    loadHash();
    await getFaqs();
});

onBeforeUnmount(() => {
    window.removeEventListener('mousemove', onMouseMove);
});

provide('registerOverviewFilter', registerFilter);

function onMouseMove(event: MouseEvent) {
    x.value = event.clientX;
    y.value = event.clientY;
}

// show and hide functions when hover categories
function hideCursor() {
    showCustomCursor.value = true;
}

function showCursor() {
    showCustomCursor.value = false;
}

// get showed faqs
async function getFaqs() {
    if (loading.value) {
        controller.abort();
        loading.value = false;
        controller = new AbortController();
    }
    try {
        loading.value = true;
        let url = `${contextPath}${FAQ_REST_ENDPOINT}/${siteName}/${lang}/${props.uuid}`;
        if (selectedCategories.length) {
            url += `?filter=${selectedCategories.join(',')}`;
        }
        const res = await fetch(url);
        if (res.status === 200) {
            result.value = (await res.json()) as FaqResult;
            faqs.value = result.value.results;
        } else {
            result.value = null;
        }
    } catch (e) {}
    loading.value = false;
    openPopupFromHash();
}

function openPopupFromHash() {
    if (loadFaqSlug.length) {
        const faq = faqs.value.find(x => punycode.toUnicode(x.url) === loadFaqSlug);
        if (faq) {
            events.$emit('open-popup', 'faq-detail');
            onFaqClicked(faq);
        }
    }
    loadFaqSlug = '';
}

function registerFilter(filter: InstanceType<typeof OverviewFilter>) {
    filters.value.push(filter);
    if (slots.filters().filter(filterItems).length === filters.value.length) {
        filtersReady.value = true;
        // check if there are any result with filters
        // add if there are any result with the filters and the current active filters
        checkAvailableFilters(true);
    }
}

function toggleCategory(
    categoryId: string,
    removeId = '',
    selection: { filter: string; category: string } = null,
    updateHash = true
) {
    const removeFilterCatId = removeId === '' ? '' : `${selection.filter}:${removeId}`;
    if (selectedCategories.includes(removeFilterCatId)) {
        if (updateHash) {
            removeFromState(selection.filter);
        }
        selectedCategories.splice(selectedCategories.indexOf(removeFilterCatId), 1);
    }
    const filterCatId = categoryId === '' ? '' : `${selection.filter}:${selection.category}`;
    if (selectedCategories.includes(filterCatId)) {
        if (updateHash) {
            removeFromState(selection.filter);
        }
        selectedCategories.splice(selectedCategories.indexOf(filterCatId), 1);
    } else if (filterCatId !== removeFilterCatId) {
        if (updateHash) {
            addToState(selection.filter, selection.category);
        }
        selectedCategories.push(filterCatId);
    }
    getFaqs();
}

function onFilterChanged({ value: id, fake }, filter) {
    const regex = new RegExp(`${filter.filterKey}:`);
    const currentCat = selectedCategories.find(x => x.match(regex));
    const oldCat = currentCat ? currentCat.replace(/^\w+:/, '') : '';
    const selectedCat = oldCat === id ? '' : id;
    const category = filter.categories.find(x => x.categoryId === selectedCat);
    toggleCategory(
        id,
        oldCat,
        {
            filter: filter.filterKey,
            category: category ? category.categoryKey : ''
        },
        !fake
    );
    // check if there are any result with the others filters
    checkAvailableFilters(false);
}

// see filters available
async function checkAvailableFilters(ifExisting: boolean) {
    for (const filterItem of filters.value) {
        // If there isn't a selection for this category, check for options available
        if (!selectedCategories.some(item => item.startsWith(filterItem.filterKey))) {
            for (const cat of filterItem.categories) {
                // check if have any faq with the filter with current active filters
                const result = await haveResults(
                    filterItem.filterKey + ':' + cat.categoryKey,
                    false
                );
                cat.disabled = !result;
                // check if have any faq with the filter
                if (ifExisting) {
                    const result = await haveResults(
                        filterItem.filterKey + ':' + cat.categoryKey,
                        true
                    );
                    cat.hidden = !result;
                }
            }
        }
    }
}

// see if have faqs with that filter
async function haveResults(cat: string, ifExisting: boolean) {
    try {
        let url = `${contextPath}${FAQ_REST_ENDPOINT}/${siteName}/${lang}/${props.uuid}`;
        if (selectedCategories.length && !ifExisting) {
            url += `?filter=${selectedCategories.join(',')}`;
            url += `,${cat}`;
        } else {
            url += `?filter=${cat}`;
        }
        const res = await fetch(url);
        if (res.status === 200) {
            return result.value.results.length > 0;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}

function loadHash(update = false) {
    const hash = location.hash.replace(/^#/, '');
    const _filters = hash.split('&').filter(x => x.includes(':'));
    _filters.forEach(f => {
        const { 0: _filterKey, 1: _categoryKey } = f
            .replace(/^([\w-]+):([\w-]+)$/, (_: string, ...args: any[]) => [...args].toString())
            .split(',');
        if (_filterKey === 'faq') {
            loadFaqSlug = _categoryKey;
        } else {
            const dropdown = dropdowns.value.find(x => x.$.vnode.key === _filterKey);
            const _filter = filters.value.find(x => x.filterKey === _filterKey);
            if (_filter) {
                const category = _filter.categories.find(x => x.categoryKey === _categoryKey);
                if (category && dropdown) {
                    dropdown.setValue(category.categoryId);
                }
            }
        }
    });
}

function selectFilter(category) {
    // to implement?
}

function onFaqClicked(faq: Faq) {
    addToState('faq', punycode.toUnicode(faq.url));
    currentFaq.value = faq;
    setTimeout(() => {
        showSlider.value = true;
    }, 500);
}

function closePopup(close: () => void) {
    removeFromState('faq', punycode.toUnicode(currentFaq.value.url));
    close();
    currentFaq.value = null;
    showSlider.value = false;
}

function randomDelay() {
    return `${Math.random() * 300}ms`;
}

function mix() {
    mixing.value = true;
    setTimeout(() => {
        shuffleArray(faqs.value);
        mixing.value = false;
    }, 1000);
}

function onFocusQuestion() {
    submitFaqOpen.value = true;
}

// pause videos in slider on index change
function stopVideos() {
    if (video.value.length) {
        video.value.forEach((vid: HTMLVideoElement) => {
            vid.pause();
        });
    }
    if (youtube.value.length) {
        youtube.value.forEach((yt: HTMLIFrameElement) => {
            yt.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        });
    }
}

async function submitFaq(e: Event) {
    const form = e.target as HTMLFormElement;
    const fd: FormData = new FormData(form);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const encodedFd: URLSearchParams = new URLSearchParams(fd as any);
    submitFaqLoading.value = true;
    try {
        if (form.checkValidity()) {
            faqSubmitted.value = true;
            const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
            const res = await fetch(
                `${contextPath}${FAQ_REST_ENDPOINT}/submit/${siteName}/${lang}`,
                {
                    method: 'POST',
                    headers,
                    body: encodedFd
                }
            );
            const data = await res.json();
            faqSubmitSuccess.value = data.success;
        }
    } catch (e) {
        faqSubmitSuccess.value = false;
    }
    submitFaqLoading.value = false;
}

function onCaptchaSolved(success: boolean) {
    this.captchaSolved.value = success;
}

return (_ctx: any,_cache: any) => {
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_friendly_captcha = _resolveComponent("friendly-captcha")!
  const _component_share_button = _resolveComponent("share-button")!
  const _component_campaign_popup = _resolveComponent("campaign-popup")!
  const _directive_popup = _resolveDirective("popup")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "stage"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (filter) => {
            return (_openBlock(), _createBlock(BizDropdown, {
              key: filter.filterKey,
              title: filter.name,
              onSelect: ($event: any) => (onFilterChanged($event, filter)),
              class: "lg:w-80",
              contrast: "",
              ref_for: true,
              ref_key: "dropdowns",
              ref: dropdowns
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.categories, (cat) => {
                  return (_openBlock(), _createBlock(_component_dropdown_item, {
                    disabled: cat.disabled,
                    hidden: cat.hidden,
                    key: cat.categoryId,
                    title: cat.name,
                    value: cat.categoryId
                  }, null, 8, ["disabled", "hidden", "title", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["title", "onSelect"]))
          }), 128))
        ])
      ])
    ]),
    (!filtersReady.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "filters")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (submitFaqLoading.value)
          ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (faqSubmitted.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (faqSubmitSuccess.value)
                      ? _renderSlot(_ctx.$slots, "success", { key: 0 })
                      : _renderSlot(_ctx.$slots, "error", { key: 1 })
                  ], 64))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _withModifiers(submitFaq, ["prevent"])
                  }, [
                    _createElementVNode("div", {
                      onClick: onFocusQuestion,
                      class: _normalizeClass(["overflow-hidden transition-all duration-1000", [
                                submitFaqOpen.value ? 'max-h-138' : 'max-h-8 border-b border-current'
                            ]])
                    }, [
                      _createElementVNode("div", {
                        onClick: onFocusQuestion,
                        class: "flex justify-between"
                      }, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.formPlaceholderLabel), 1),
                        (!submitFaqOpen.value)
                          ? (_openBlock(), _createBlock(BizIcon, {
                              key: 0,
                              name: "email",
                              class: _normalizeClass(["ml-4 h-4 w-4 shrink-0 fill-current", { submitFaqOpen: 'hidden' }])
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "site",
                        id: "site",
                        value: _unref(siteName)
                      }, null, 8, _hoisted_9),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "locale",
                        id: "locale",
                        value: _unref(lang)
                      }, null, 8, _hoisted_10),
                      _createElementVNode("input", {
                        type: "hidden",
                        name: "url",
                        id: "url",
                        value: _unref(pageUrl)
                      }, null, 8, _hoisted_11),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("textarea", {
                          name: "question",
                          required: "",
                          id: "description",
                          placeholder: __props.questionFieldLabel,
                          rows: "5",
                          class: "form-input resize-none transition-all duration-1000"
                        }, null, 8, _hoisted_13),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(__props.questionFieldLabel) + " * ", 1)
                      ]),
                      _createElementVNode("label", _hoisted_15, [
                        _createElementVNode("input", {
                          type: "text",
                          name: "name",
                          placeholder: __props.nameFieldLabel,
                          required: "",
                          class: "form-input"
                        }, null, 8, _hoisted_16),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(__props.nameFieldLabel) + " *", 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_friendly_captcha, {
                          sitekey: __props.captchaSiteKey,
                          onSolve: onCaptchaSolved,
                          classes: "w-full !max-w-full h-fit lg:ml-auto lg:w-1/2"
                        }, null, 8, ["sitekey"]),
                        _createElementVNode("button", {
                          disabled: !captchaSolved.value,
                          type: "submit",
                          class: "button button-primary group relative mt-12 ml-auto flex items-center disabled:opacity-50"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(__props.submitFaqLabel), 1),
                          _createVNode(BizIcon, {
                            name: "email",
                            class: "ml-4 h-4 w-4 shrink-0 fill-current"
                          })
                        ], 8, _hoisted_19)
                      ])
                    ], 2)
                  ], 40, _hoisted_7))
            ], 64)),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        onClick: mix,
        class: "inline-flex items-center border-b border-transparent font-medium transition-colors hover:border-gray-500"
      }, [
        _createTextVNode(_toDisplayString(__props.mixLabel) + " ", 1),
        _createVNode(BizIcon, {
          name: "dice",
          class: "ml-3 h-6 w-6 fill-current text-gray-500"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (faq, i) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: faq.id,
          class: _normalizeClass(["group-1 faq-item relative pt-1/1 transition-all duration-300", [
                    i % 5 === 3 || i % 5 === 4 ? 'lg:col-span-3' : 'lg:col-span-2',
                    { 'scale-0 opacity-0': mixing.value }
                ]]),
          style: _normalizeStyle({ transitionDelay: randomDelay() }),
          onClick: ($event: any) => (onFaqClicked(faq))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["absolute left-0 top-0 flex h-full w-full flex-col p-6 lg:p-12", {
                        'bg-black text-white': faq.style === 'contrast',
                        'bg-gray-100': faq.style === 'semi',
                        'justify-end': !!faq.image && i % 5 !== 3 && i % 5 !== 4,
                        'justify-between': !faq.image || i % 5 === 3 || i % 5 === 4
                    }])
          }, [
            _createElementVNode("div", _hoisted_23, [
              ((i % 5 === 3 || i % 5 === 4) && faq.questioner && faq.responder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(faq.questioner), 1),
                      _createTextVNode(" " + _toDisplayString(__props.asksLabel), 1)
                    ]),
                    _hoisted_25,
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(faq.responder), 1),
                      _createTextVNode(" " + _toDisplayString(__props.answersLabel), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_26, [
              (faq.questioner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("b", null, _toDisplayString(faq.questioner), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-1", [
                                    faq.style === 'contrast' ? 'text-white/80' : 'text-gray-400'
                                ]])
                    }, _toDisplayString(__props.questionerLabel), 3)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["relative z-10 break-words font-quote text-2xl", [
                                !faq.image || i % 5 === 3 || i % 5 === 4
                                    ? 'lg:text-4xl'
                                    : 'lg:text-3xl'
                            ]])
              }, _toDisplayString(faq.question), 3)
            ]),
            _createElementVNode("div", _hoisted_28, [
              (faq.categories && faq.categories.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.categories, (cat) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: cat.name,
                        class: _normalizeClass([[
                                    faq.style === 'contrast'
                                        ? 'border-white text-white'
                                        : 'border-gray-400 text-gray-400'
                                ], "min-w-[1.75rem] cursor-pointer border py-0.5 text-sm transition-colors"])
                      }, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(cat.title), 1)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_31, [
              (faq.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: faq.image,
                    alt: faq.imageAlt,
                    class: "absolute left-0 top-0 h-full w-full object-cover object-center transition-transform duration-500 group-1-hover:scale-105"
                  }, null, 8, _hoisted_32))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["absolute left-0 bottom-0 h-2/3 w-full bg-gradient-to-t", [
                                faq.style === 'contrast' ? 'from-gray-500/75' : 'from-white/75'
                            ]])
              }, null, 2)
            ])
          ], 2)
        ], 14, _hoisted_22)), [
          [_directive_popup, void 0, "faq-detail"]
        ])
      }), 128)),
      _createElementVNode("div", {
        class: _normalizeClass(showCustomCursor.value ? 'hidden' : 'absolute')
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle({ left: `${x.value}px`, top: `${y.value}px` }),
          class: "pointer-events-none z-20 hidden h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/25 backdrop-blur-sm group-hover:fixed lg:flex"
        }, [
          _createVNode(BizIcon, {
            name: "plus-thin",
            class: "h-6 w-6 fill-current text-gray-500"
          })
        ], 4)
      ], 2)
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_campaign_popup, { id: "faq-detail" }, {
      default: _withCtx(({ close }) => [
        _createElementVNode("div", {
          class: "h-full w-full",
          onClick: ($event: any) => (closePopup(close))
        }, [
          _createElementVNode("div", {
            class: "container h-full",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                (currentFaq.value.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: currentFaq.value.image,
                      alt: currentFaq.value.imageAlt,
                      class: "absolute left-0 top-0 h-full w-full object-cover object-center"
                    }, null, 8, _hoisted_36))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["absolute left-0 bottom-0 h-2/3 w-full bg-gradient-to-t", [
                                        currentFaq.value.style === 'contrast'
                                            ? 'from-gray-500/75'
                                            : 'from-white/75'
                                    ]])
                }, null, 2)
              ]),
              _createElementVNode("button", {
                class: "absolute z-30 flex items-center font-bold text-gray-400 lg:relative",
                onClick: ($event: any) => (closePopup(close))
              }, [
                _createVNode(BizIcon, {
                  class: "mr-3 h-3 w-3 shrink-0 rotate-180 transform fill-current",
                  name: "chevron-right"
                }),
                _createTextVNode(" " + _toDisplayString(__props.backLabel), 1)
              ], 8, _hoisted_37),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("b", {
                      class: _normalizeClass(["lg:hidden", {
                                                'text-white': currentFaq.value.style === 'contrast'
                                            }])
                    }, _toDisplayString(currentFaq.value.questioner), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-1 lg:hidden", {
                                                'text-white': currentFaq.value.style === 'contrast'
                                            }])
                    }, _toDisplayString(__props.questionerLabel), 3),
                    _createElementVNode("h3", {
                      class: _normalizeClass(["mb-16 font-quote font-normal lg:mb-5 lg:text-black", {
                                                'text-white': currentFaq.value.style === 'contrast'
                                            }])
                    }, _toDisplayString(currentFaq.value.question), 3),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(__props.questionFromLabel), 1),
                    _createElementVNode("b", _hoisted_42, _toDisplayString(currentFaq.value.questioner), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("b", _hoisted_45, _toDisplayString(currentFaq.value.responder) + " " + _toDisplayString(__props.answersLabel), 1),
                    _hoisted_46,
                    _createElementVNode("div", {
                      innerHTML: currentFaq.value.answer
                    }, null, 8, _hoisted_47)
                  ]),
                  (currentFaq.value.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: currentFaq.value.link,
                        target: currentFaq.value.linktarget,
                        class: "button button-secondary"
                      }, _toDisplayString(currentFaq.value.linklabel
                                                ? currentFaq.value.linklabel
                                                : __props.moreInfoLabel), 9, _hoisted_48))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  (showSlider.value)
                    ? (_openBlock(), _createBlock(BizSlider, {
                        key: 0,
                        class: "relative !h-auto pb-8 lg:pb-20",
                        "slide-classes": "w-full",
                        mousewheel: "",
                        "container-classes": "pb-8 pr-container-screen",
                        onIndexChanged: stopVideos,
                        gap: 16,
                        "wrapper-classes": "w-full"
                      }, {
                        pagination: _withCtx(({ index, total }) => [
                          (total > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", {
                                      style: _normalizeStyle(`--tw-scale-x: ${
                                                                index / total
                                                            }`),
                                      class: "absolute h-full w-full origin-left transform bg-black transition-transform"
                                    }, null, 4)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFaq.value.media, (img) => {
                            return (_openBlock(), _createBlock(BizSlide, {
                              mousewheel: "",
                              class: "relative h-0 w-full pt-1/1",
                              key: img
                            }, {
                              default: _withCtx(() => [
                                (img.type === 'image')
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: img.src,
                                      class: "absolute left-0 top-0 h-full w-full object-cover object-center lg:max-h-[60vh]"
                                    }, null, 8, _hoisted_53))
                                  : (img.type === 'video')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("video", {
                                            preload: "auto",
                                            controls: "",
                                            ref_for: true,
                                            ref_key: "video",
                                            ref: video,
                                            playsinline: "",
                                            "webkit-playsinline": "",
                                            class: "absolute top-0 left-0 h-full w-full object-contain"
                                          }, [
                                            _createElementVNode("source", {
                                              src: `${img.src}#t=0.001`,
                                              type: _unref(getMimeType)(img.src)
                                            }, null, 8, _hoisted_56)
                                          ], 512)
                                        ])
                                      ]))
                                    : (img.type === 'youtube')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("iframe", {
                                              title: "Youtube Video",
                                              ref_for: true,
                                              ref_key: "youtube",
                                              ref: youtube,
                                              class: "absolute top-0 left-0 h-full w-full object-contain",
                                              src: `https://www.youtube.com/embed/${img.src}?playsinline=1&showinfo=0&rel=0&enablejsapi=1`,
                                              allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture",
                                              allowfullscreen: ""
                                            }, null, 8, _hoisted_59)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (currentFaq.value.categories && currentFaq.value.categories.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_60, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFaq.value.categories, (cat) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: cat.name,
                          class: "mr-2 mb-2 min-w-[1.75rem] cursor-default border border-gray-400 py-0.5 text-sm text-gray-400 transition-colors lg:mr-0 lg:ml-2"
                        }, [
                          _createElementVNode("span", _hoisted_61, _toDisplayString(cat.title), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_share_button, {
                  share: __props.shareLabel,
                  class: "mt-14 lg:col-start-2 lg:row-start-3 lg:!ml-auto lg:mt-auto lg:justify-end"
                }, null, 8, ["share"])
              ])
            ])
          ])
        ], 8, _hoisted_33)
      ]),
      _: 1
    })
  ], 512))
}
}

})